<template>
    <section class="position-overview">
        <div class="position-overview__grid">
            <div v-for="kpi in kpis" :key="kpi.key" class="kpi-card">
                <span class="kpi-card__value">{{ kpi.value }}</span>
                <span class="kpi-card__label">{{ kpi.label }}</span>
                <span v-if="kpi.hint" class="kpi-card__hint">{{ kpi.hint }}</span>
            </div>
        </div>
        <p class="position-overview__meta">{{ metaText }}</p>
    </section>
</template>

<script setup>
import { computed } from 'vue';
import { getPositionKpis } from '@/utils/playerStatsCalculator';

const props = defineProps({
    stats: { type: Object, default: () => ({}) },
    position: { type: String, default: null },
});

const kpis = computed(() => getPositionKpis(props.position, props.stats || {}));

const metaText = computed(() => {
    const m = props.stats?.matches_played ?? 0;
    const s = props.stats?.sets_played ?? 0;
    return `${m} матчей · ${s} партий`;
});
</script>
